// Vendors
import React from 'react';
import { Tabs, Tab, Box } from '@mui/material';

// Assets
import tickIcon from '@/assets/icons/tick-icon.svg';
interface TabsProps {
  labels: string[];
  selectedTab: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
  showTickIcon?: boolean;
  containerName: string;
}

const CustomTabs: React.FC<TabsProps> = ({
  labels,
  selectedTab,
  onChange,
  showTickIcon = false,
  containerName = '',
}) => {
  return (
    <Tabs value={selectedTab} onChange={onChange} className={containerName}>
      {labels.map((label, index) => (
        <Tab
          key={index}
          value={index}
          label={
            <Box className="tab_wrapper" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              {selectedTab === index && showTickIcon && (
                <img src={tickIcon} alt="tick" className="tick-icon" />
              )}
              {label}
            </Box>
          }
          sx={{ textTransform: 'none' }}
        />
      ))}
    </Tabs>
  );
};

export default CustomTabs;
